// import AuthView from '../views/auth/AuthView';
import HomePage from '../views/HomePage';
import Shop from '../views/Shop';
import ShoppingCart from '../views/ShoppingCart';
import Checkout from '../views/Checkout';
import Login from '../views/Admin/Login';
import Tables from '../views/Admin/Tables';
import Profile from '../views/Admin/Profile';
import Index from '../views/Admin/Index';
import Category from '../views/Admin/Category';
import FAQ from '../views/FAQ';
import Blogs from '../views/Blogs';
import AdminBlogs from '../views/Admin/AdminBlogs';

let routes = [
	{
		path: '/index',
		name: 'Dashboard',
		icon: 'ni ni-tv-2 text-primary',
		component: Index,
		layout: 'admin',
	},

	{
		path: '/adminblog',
		name: 'Blogs',
		icon: 'ni ni-key-25 text-info',
		component: AdminBlogs,
		layout: 'admin',
	},
	{
		path: '/category',
		name: 'Category',
		icon: 'ni ni-single-02 text-yellow',
		component: Category,
		layout: 'admin',
	},
	{
		path: '/tables',
		name: 'Products',
		icon: 'ni ni-bullet-list-67 text-red',
		component: Tables,
		layout: 'admin',
	},
	// {
	// 	path: '/user-profile',
	// 	name: 'User Profile',
	// 	icon: 'ni ni-single-02 text-yellow',
	// 	component: Profile,
	// 	layout: 'admin',
	// },
	{
		path: '/login',
		name: 'Login',
		icon: 'ni ni-key-25 text-info',
		component: Login,
		layout: 'auth',
	},
	{
		path: '/',
		component: HomePage,
		layout: 'main',
	},
	{
		path: '/blog',
		component: Blogs,
		layout: 'main',
	},
	{
		path: '/shop',
		component: Shop,
		layout: 'main',
	},
	{
		path: '/shoppingcart',
		component: ShoppingCart,
		layout: 'main',
	},
	{
		path: '/Checkout',
		component: Checkout,
		layout: 'main',
	},
	{
		path: '/faqs',
		component: FAQ,
		layout: 'main',
	},
];
export default routes;
